<template>
    <v-app :style="cssVars" id="inspire">
        <v-content class="background">
            <header-component></header-component>
            <v-container class="pt-0 pb-12 mt-8" style="align-items: start" v-bind:class="{'px-0 pt-0': $route.meta.fullWidth}">
                <div v-bind:class="{'full-width': $route.meta.fullWidth}">
                    <transition name="fade-in" mode="out-in">
                        <router-view :key="key" />
                    </transition>
                </div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    const HeaderComponent = () => ({
        component: import('./views/informations/header.vue'),
        timeout: 3000
    })
    export default {
        name: 'App',
        components:{
            HeaderComponent,
        },
        computed: {
            cssVars() {
                var to_return = {};
                for(var index in this.$vuetify.theme.themes.light){
                    to_return['--'+index+'-color'] = this.$vuetify.theme.themes.light[index];
                }
                return to_return;
            },
            app(){
                return this.$store.getters.app;
            },
            key() {
                return this.$route.fullPath;
            },
            header(){
                return this.$store.getters.header;
            },
        },
        data(){
            return{
                tutorial_confirm: false,
                open_leftbar: false,
            }
        }
    };
</script>
<style lang="scss">
    @import "scss/custom";
    @media screen and (max-width: 1200px){
        .my-container{
            width: 100%;
            max-width: 100%;
        }
    }
    .my-label{
        font-weight: bold;
    }

</style>
